module.exports = __webpack_public_path__ + "static/media/SortMahJong.353dfdf5.jpg";